'use client';

import { storyblokEditable } from '@storyblok/react/rsc';
import clsx from 'clsx';
import { FC } from 'react';
import { BannerHeroSlideStoryblok, BannerHeroStoryblok } from 'storyblok-types';
import { Button } from 'atoms/Button';
import { IButton } from 'atoms/Button/types';
import { Image } from 'atoms/Image/Image';
import { HeadLine } from 'atoms/Typography/Typography';
import { useMediaQuery } from 'modules/mui/hooks';
import styles from './BannerHero.module.css';

const Slide: FC<{ slide: BannerHeroSlideStoryblok }> = ({ slide }) => {
  const { type } = useMediaQuery();
  const image = slide[`${type}Image`];
  const btn = slide.cta?.[0];

  return (
    <div className={styles.slide}>
      <Image className={styles.image} src={image?.filename} alt={image?.alt} />
      <div
        className={clsx(
          styles.contentWrapper,
          styles[`${slide.contentPositionVertical}V`],
          styles[`${slide.contentPositionHorizontal}H`],
        )}
      >
        <div className={clsx(styles.content)}>
          <div>
            {slide.headline && (
              <HeadLine type="md" className={styles.text}>
                {slide.headline}
              </HeadLine>
            )}
          </div>
          <div>
            {slide.subHeadline && (
              <HeadLine
                type="md"
                className={clsx(styles.text, styles.subHeadline)}
              >
                {slide.subHeadline}
              </HeadLine>
            )}
          </div>
          <div>
            {slide.bodyText && (
              <HeadLine type="xs" className={styles.text}>
                {slide.bodyText}
              </HeadLine>
            )}
          </div>
          <div className={styles.btnContainer}>
            {btn && (
              <Button href={btn.href} color={btn.color as IButton['color']}>
                {btn.value}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const BannerHero: FC<{ blok?: BannerHeroStoryblok }> = ({ blok }) => {
  //temp solution, in future should be slider
  const currentSlide = blok?.slides?.[0];

  if (!currentSlide) {
    return null;
  }

  return (
    <div className={styles.slides} {...storyblokEditable(blok)}>
      <Slide slide={currentSlide} />
    </div>
  );
};
